import { fetchData } from "./fetchData";

export const getUserData = async (data) => {
    return await fetchData('usuarios/', {
        method: 'POST',
        body: JSON.stringify(data),
    });
};